:root {
  --header-height: calc(var(--mirai-ui-space-XL) * 2);
}

/* -- defaults -------------------------------------------------------------- */
body {
  color: var(--mirai-ui-content);
  margin: 0;
  padding: 0;
}

/* -- App.container.jsx ----------------------------------------------------- */
.wrapper {
  align-self: center;
  max-width: var(--mirai-ui-breakpoint-content);
  width: 100%;
}

.wrapper.centered {
  justify-content: center;
  justify-content: space-between;
}

.header,
.footer {
  width: 100vw;
  z-index: 0;
}

.header {
  background-color: var(--mirai-ui-base);
  overflow-x: hidden;
  padding: var(--mirai-ui-space-S);
}

.header [data-role='action'] {
  text-decoration: none;
}

.header .environment {
  align-items: right;
  border-bottom: solid 1px var(--mirai-ui-content-border);
  margin-bottom: var(--mirai-ui-space-XS);
  padding-bottom: var(--mirai-ui-space-XS);
}

.header .environment .contact {
  flex: 1;
  color: var(--mirai-ui-content-light);
}

.header > .main > * {
  flex: 1;
  align-items: center;
}

.header > .main > *:first-child {
  justify-content: flex-start;
}

.header > .main > *:last-child {
  justify-content: flex-end;
}

.header > .main > *:first-child,
.header > .main > *:last-child {
  gap: var(--mirai-ui-space-L);
}

.footer {
  background-color: var(--mirai-ui-content);
}

.footer [data-role='text'] {
  color: var(--mirai-ui-base);
}

.footer ui-modal [data-role='text'] {
  color: var(--mirai-ui-content);
}

.footer .links {
  align-items: flex-start;
  justify-content: space-between;
}

.footer .links [data-role='action'] {
  color: var(--mirai-ui-content-border);
}

.footer .links [data-role='action']:hover {
  color: var(--mirai-ui-base);
}

.footer .links > * {
  gap: var(--mirai-ui-space-XS);
}

.footer .links .newsletter {
  width: 33%;
}

.footer .links .newsletter [data-role='input'] {
  background-color: transparent;
  border-bottom: solid 1px var(--mirai-ui-content-light);
  padding-bottom: var(--mirai-ui-space-XS);
}

.footer .copyright {
  border-top: solid 1px var(--mirai-ui-content-light);
}

/* S */
@media only screen and (max-width: 480px) {
  .hideMobile {
    display: none;
  }

  .header .environment {
    justify-content: flex-end;
  }

  .children {
    min-height: 61vh;
  }

  .footer {
    padding: var(--mirai-ui-space-L) var(--mirai-ui-space-M);
  }

  .footer .copyright {
    border-top: solid 1px var(--mirai-ui-content-light);
    margin-top: var(--mirai-ui-space-L);
    padding-top: var(--mirai-ui-space-M);
  }
}

/* M & L */
@media only screen and (min-width: 431px) {
  .footer {
    padding: var(--mirai-ui-space-XL) var(--mirai-ui-space-M);
  }

  .footer .copyright {
    margin-top: var(--mirai-ui-space-XL);
    padding-top: var(--mirai-ui-space-L);
  }
}

@media print {
  .footer {
    display: none;
  }
}
